import Authentication from "@/components/Auth/Authentication";

export default [
  {
    name: "auth",
    path: "/login",
    components: {
      main: Authentication
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/auth.js